import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      t="1639474072746"
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="4211"
      width="200"
      height="200"
    >
      <path
        d="M512 128c212 0 384 172 384 384s-172 384-384 384-384-172-384-384 172-384 384-384m0-64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z"
        p-id="4212"
      />
      <path
        d="M480 704h64v64h-64zM480 256h64v384h-64z"
        p-id="4213"
      />
    </svg>
  )
}
const WarningIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon fill={fill} />
    </MorphReplace>
  )
}

// 默认参数
WarningIcon.defaultProps = {
  width: 15,
  height: 15,
  fill: '#F4BD0E',
}
// 参数类型
WarningIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default WarningIcon
